import { useMemo } from "react";

import type { ExistingOptionDefaultQuery } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useInitProductOptionFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-mode/server-model-to-input-mode";
import { useOptionEditMutation } from "../../../repository/existing";

import type { ProductExistingOptionFormModelContextType } from "../../../../ui/existing/context/context";
import type { QueryData } from "../../../type";

type Props = {
	serverModel: ExistingOptionDefaultQuery;
};

export const useInitialized = ({ serverModel }: Props): ProductExistingOptionFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = {
		hotelPolicy: {
			cancelPolicy: serverModel.hotelPolicy?.cancelPolicy ?? [],
			requiredPrepMillisecond: serverModel.hotelPolicy?.requiredPrepMillisecond ?? 0,
		},
		connection: {
			planNameAndIDOptions: [
				...serverModel.planList.plans.map(
					(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
				),
				...serverModel.planList.secrets.map(
					(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
				),
			],
		},
		discountList: serverModel.discountList,
	} satisfies QueryData;

	const { onSetViewModel, viewModel, resetViewModel } = useInitProductOptionFormModelContext({
		inputModel,
		queryData,
	});

	const { onUpdate } = useOptionEditMutation({ resetForm: resetViewModel });

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
